import { api } from './api';
import { getText, state } from './service';
import { sdkOpenLink, isSdk } from './sdkCtrl';
import { isFBAndroid } from './utils';
import '../img/fb/fb-en.jpg'
import '../img/fb/fb-ja.jpg'
import '../img/fb/fb-kr.jpg'
import '../img/fb/fb-tw.jpg'

const getLoginStatus = isClean => {
	return new Promise(resolve => {
		FB.getLoginStatus(response => {
			resolve(response.status === 'connected');
		}, isClean);
	});
};

const fbLogin = () => {
	return new Promise(resolve => {
		FB.login(function (response) {
			resolve(response.status === 'connected');
		});
	});
};

const getFbUserInfo = function () {
	return new Promise(resolve => {
		FB.api('/me', function (res) {
			resolve({ fb_id: res.id, fb_name: res.name });
		});
	});
};

const excShare = info => {
	return new Promise(resolve => {
		FB.ui(info, function (res) {
			resolve(res && !res.error_message);
		});
	});
};

export const fbShare = async () => {
	const fbImgMap = {
		'en-us': 'fb-en',
		'zh-tw': 'fb-tw',
		'ko-kr': 'fb-kr',
		'ja-jp': 'fb-ja',
	};
	const fbLinkMap = {
		'en-us': 'https://www.facebook.com/PnS.37Games',
		'zh-tw': 'https://www.facebook.com/PnS.TW',
		'ko-kr': 'https://www.facebook.com/puzzleofZ.KR/',
	};
	let fbImg = fbImgMap[state.lang] || 'fb-en';
	let fbLink = fbLinkMap[state.lang] || 'https://www.facebook.com/PnS.37Games';
	const message = getText('fbText').replace('${cipher}', state.groupCode);
	const title = getText('ruleMainTitle');
	let picUrl = `https://gevents.pnsofficial.com/pnskfsquadron/img/${fbImg}.jpg`;
	let shareUrl = `https://gevents.pnsofficial.com/pnskfsquadron/index.html?cid=share&scid=fb&inviteCode=${state.groupCode}&tag=${state.tag}`;
	let info = {
		method: 'share',
		href: `https://gactivityapi.pnsofficial.com/fbShareCustomize/customizeShare/message/${encodeURIComponent(message)}/app_id/3064961960303755/share_title/${encodeURIComponent(title)}/redict_url/${encodeURIComponent(
			shareUrl
		)}/pic_url/${encodeURIComponent(picUrl)}`,
		display: 'popup',
	};
	if (isFBAndroid) {
		info.href = encodeURIComponent(info.href);
	}
	if (isSdk) {
		sdkOpenLink(fbLink);
	} else {
		let checkRes = await getLoginStatus();
		!checkRes && (await fbLogin());
		await excShare(info);
	}
	await share();
};

export const twShare = async () => {
	if (isSdk) {
		sdkOpenLink('https://twitter.com/37games_pnsjp');
	} else {
		let title = getText('copyShareText').replace('${cipher}', state.groupCode);
		let link = "https://gevents.pnsofficial.com/pnskfsquadron/index.html?cid=share&scid=twitter&inviteCode=" + state.groupCode + "&tag=" + state.tag;
		let url = '//twitter.com/intent/tweet?text=' + encodeURIComponent(title) + ' ' + encodeURIComponent(link);
		window.open(url);
	}
	await share();
};

export const dcShare = async () => {
	if (isSdk) {
		sdkOpenLink('https://discord.gg/puzzlesandsurvival');
	} else {
		window.open('https://discord.gg/puzzlesandsurvival');
	}
	await share();
};

export const nvShare = async () => {
	if (isSdk) {
		sdkOpenLink('https://game.naver.com/lounge/puzzle_of_Z/home');
	} else {
		window.open('https://game.naver.com/lounge/puzzle_of_Z/home');
	}
	await share();
};

export const share = async () => {
	const res = await api.completeShare({ avatar_id: state.curHero });
	if (res && +res.result === 1) {
		// 更新任务状态
		console.log(res.code);
	}
};

export const fbInit = async (lang) => {
	const shareLanguageReflect = {
		'en-us': 'en_US',
		'zh-tw': 'zh_TW',
		'ko-kr': 'ko_KR',
		'ja-jp': 'ja_JP',
	};
	window.fbAsyncInit = function () {
		FB.init({
			appId: '3064961960303755',
			autoLogAppEvents: true,
			xfbml: true,
			version: 'v17.0',
			status: true,
		});
		FB.getLoginStatus(function (response) {
			window.fbState = response.status === 'connected';
		});
		FB.AppEvents.logPageView();
	};
	(function (d, s, id) {
		let js;
		const fjs = d.getElementsByTagName(s)[0];
		if (d.getElementById(id)) {
			return;
		}
		js = d.createElement(s);
		js.id = id;
		js.src =
			'//connect.facebook.net/' + shareLanguageReflect[lang] + '/sdk.js';
		fjs.parentNode.insertBefore(js, fjs);
	})(document, 'script', 'facebook-jssdk');
}